<template>
  <li>
    <router-link
      class="menu__item"
      :to="{ path: `/${menuItem.moduleURL}` }"
      @click.native="$root.$emit('collapse', false)"
      v-if="!menuItem.child"
    >
      <i :class="`mdi mdi-${menuItem.icon || 'circle-medium'}`"> </i>
      <span>{{ menuItem.name }}</span>
    </router-link>
    <div v-if="menuItem.child">
      <span class="menu__item" @click="isOpen = !isOpen">
        <i :class="`mdi mdi-${menuItem.icon || 'circle-medium'}`"> </i>
        <span>
          <span>
            {{ menuItem.name }}
          </span>
          <span class="arrow">
            <i class="mdi" :class="`mdi-chevron-${isOpen ? 'up' : 'down'}`"></i>
          </span>
        </span>
      </span>
      <transition name="menu-animation">
        <pw-sidebar-menu v-show="isOpen" :menu="menuItem.child" />
      </transition>
    </div>
  </li>
</template>

<script>
export default {
  name: 'SidebarMenuItem',
  components: {
    'pw-sidebar-menu': () => import('./SidebarMenu.vue'),
  },
  props: {
    menuItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  watch: {
    $route() {
      // this.$root.$emit('collapse', false)
    },
  },
};
</script>

<style lang="scss">
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.menu-animation-enter-active {
  transition: opacity 0.1s linear;
}
.menu-animation-leave-active {
  transition: opacity 0.1s linear;
}
.menu-animation-enter,
.menu-animation-leave-to {
  opacity: 0;
}
.menu__item {
  height: 40px;
  display: flex;
  font-size: 14px;
  text-decoration: none !important;
  padding-right: 15px;
  padding-left: 15px;
  // transition: all 0.1s ease-in-out;
  cursor: pointer;
  color: #5b5b5b;
  &:hover {
    background-color: #dee8ff;
    span {
      color: #5b89f2;
    }
    .mdi {
      color: #5b89f2;
    }
  }
  & + .sidebar-menu {
    padding-left: 15px;
  }
  i.mdi {
    font-size: 20px;
    display: flex;
    width: 14%;
    align-items: center;
    color: #9ba2a8;
  }
  & > span {
    display: flex;
    width: 86%;
    align-items: center;
    opacity: 1;
    transition: all 0.2s ease-in-out;
    word-break: keep-all;
    color: #707070;
    span {
      &:first-child {
        flex: auto;
      }
    }
  }
}
.sidebar--collapsed {
  /*
  .menu__item {
    overflow: hidden;
    & > span {
      opacity: 0;
    }
    & + .sidebar-menu {
      padding-left: 0;
    }
  }
  */
}
.is-open {
  & > .sidebar-menu {
    display: block;
  }
}
</style>
